import { FieldPath, FieldValues, useController } from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";
import { SyntheticEvent } from "react";
import { RhfInputProps } from "../../../Forms/RhfInputProps";
import { textFieldDefaultProps } from "../../../Forms/TextFieldDefaultProps";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { isElementInArray } from "../../../Utils/arrays";
import { TextMaskCustom } from "../../../Forms/TextMaskFacade";
import {
  TIME_MASK_ZEROHOUR_ZEROMINUTES,
  TIME_MASK_ZEROHOUR_ZEROMINUTES_24H,
} from "../../../Forms/Constants/TimeConstants";
import { disabledMuiStyle } from "../../../MaterialUi/disabledMuiStyle";

type Props = {
  label?: string;
};

export const RhfHandlingTimeTextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  required,
  disabled,
  disabledFields,
  ...otherProps
}: RhfInputProps<TFieldValues, TName> & Props & MdmFormProps & TextFieldProps) => {
  const {
    field,
    fieldState: { error },
    formState: { disabled: isFormDisabled },
  } = useController({ control, name });

  return (
    <TextField
      {...field}
      {...textFieldDefaultProps}
      {...otherProps}
      label={label}
      required={required}
      error={!!error}
      placeholder={TIME_MASK_ZEROHOUR_ZEROMINUTES_24H}
      helperText={error?.message}
      InputProps={{
        inputComponent: TextMaskCustom as any,
        inputProps: {
          mask: TIME_MASK_ZEROHOUR_ZEROMINUTES,
          onAccept: (value: string, _: HTMLInputElement | null, event: SyntheticEvent) => {
            if (event) field.onChange(value);
          },
          definitions: {
            "#": /[0-9]/,
          },
          readOnly: isFormDisabled || disabled || isElementInArray(disabledFields, name),
          style: { ...disabledMuiStyle(isFormDisabled || disabled) },
        },
      }}
    />
  );
};
